import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { multiPointsTypes } from 'src/core/lib/utils';
import { BtsList } from 'src/core/models/bts';
import { HelpersService } from 'src/core/services/helpers.service';

@Component({
  selector: 'app-modal-multi-points',
  templateUrl: './modal-multi-points.component.html',
  styleUrls: ['./modal-multi-points.component.scss']
})

export class ModalMultiPointsComponent implements OnInit {
  @Input() elements: BtsList;
  @Input() end: any;
  @Output() selectElement: EventEmitter<any> = new EventEmitter();
  @Output() dismissModal: EventEmitter<any> = new EventEmitter();
  public wait = true;
  public multiPointsTypes = multiPointsTypes;

  constructor(private helpersService: HelpersService) {}

  ngOnInit() {
    if (this.elements) {
      this.wait = this.elements ? false : true;
    }
  }

  public open(elements) {
    this.elements = elements;
    this.helpersService.open('multiPointsModal');
  }

}
